const langs = {
    ru: {
        v: function (index) { return this[index] ?? index; },
        "Подключить": "Подключить",
        "Подробнее об услуге": "Подробнее об услуге",
        "Согласен с условиями предоставления сервиса": "Согласен с условиями предоставления сервиса",
        "Ваш номер телефона": "Ваш номер телефона",
        "Некорректный номер": "Услуга доступна только в сети MegaCom",
        "На русском": "Кыргыз тилинде",
        "Подтвердить": "Подтвердить",
        "Неправильный SMS-код": "Неправильный SMS-код",
        "SMS timer 1": "Через",
        "SMS timer 2": "можете повторно отправить SMS",
        "Превышено максимальное количество попыток ввода": "Превышен лимит ввода неправильного SMS-кода. Просьба повторить через некоторое время"
    },
    kg: {
        v: function (index) { return this[index] ?? index; },
        "Подключить": "Кошуу",
        "Подробнее об услуге": "Толук маалымат",
        "Согласен с условиями предоставления сервиса": "Тейлөө шарттарына макулмун",
        "Ваш номер телефона": "Сиздин номериңиз",
        "Некорректный номер": "Кызмат MegaCom тармагында гана жеткиликтүү",
        "На русском": "На русском",
        "Подтвердить": "Кошуу",
        "Неправильный SMS-код": "Туура эмес SMS-код",
        "Вам выслан SMS-код, введите его": "Сизге SMS-код жөнөтүлдү, ал кодту териңиз",
        "Условия предоставления сервиса": "Тейлөө шарттары",
        "Повторить SMS": "SMS-ти кайталоо",
        "SMS timer 1": "SMSти кайталоого",
        "SMS timer 2": "калды",
        "← Назад": "← Артка",
        "Превышено максимальное количество попыток ввода": "Туура эмес SMS кодун киргизүү чегинен ашты. Бир аздан кийин кайталаңыз",
        "Время SMS-кода истекло": "SMS кодунун убакыты бүттү"

    }
}

export default langs;